import {ChangeDetectionStrategy, Component, Inject, Input, Optional} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Home365Constants } from '../../Contants';

type ModalSize = 's' | 'm' | 'l' | 'xl' | 'xxl';
export interface LoaderModalData {
  size: ModalSize;
  white?: boolean;
}

@Component({
  selector: 'home365-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'home365-loader'
  }
})

export class LoaderComponent {
  // @deprecated - Use size instead
  @Input() diameter: number = 0;
  @Input() white: boolean = false;

  @Input() set size(value: ModalSize) {
    switch (value) {
      case 's':
        this.diameter = Home365Constants.marginUnit * 2;
        break;
      case 'm':
        this.diameter = Home365Constants.marginUnit * 3;
        break;
      case 'l':
        this.diameter = Home365Constants.marginUnit * 6;
        break;
      case 'xl':
        this.diameter = Home365Constants.marginUnit * 8;
        break;
      case 'xxl':
        this.diameter = Home365Constants.marginUnit * 10;
        break;
    }
  }

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: LoaderModalData) {
    if (this.data) {
      this.size = data.size;
      this.white = data.white ?? false;
    }
  }
}
